import styled from "styled-components";

export default styled.a`
  color: #1f81df;
  cursor: pointer;
`;
